import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import PubPvtCaseOnHoldTable from "../../components/PubPvtCaseHoldTable";

const Pubpvtcaseonhold = () => {
  return (
    <Box>
      <MainHeader headingText={"Pub/Pvt Cases on Hold"} />

      <PubPvtCaseOnHoldTable />
    </Box>
  );
};

export default Pubpvtcaseonhold;
